import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
@Injectable()
export class TooltipOverlayContainer extends OverlayContainer {
  protected _createContainer(): void {
    if (this._containerElement) {
      return;
    }
    const existingContainers = document.getElementsByClassName('tooltip-overlay-container');
    if (existingContainers.length > 0) {
      this._containerElement = existingContainers[0] as HTMLElement;
      return;
    }
    const container = document.createElement('div');
    container.classList.add('cdk-overlay-container', 'tooltip-overlay-container');
    document.body.appendChild(container);
    this._containerElement = container;
  }
}
